import { render } from "./PersonDetailLink.vue?vue&type=template&id=1815f1c8"
import script from "./PersonDetailLink.vue?vue&type=script&lang=js"
export * from "./PersonDetailLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__